export const getBaseUrlInServer = async () => {
  const { headers } = await import('next/headers');

  const headersList = headers();

  const forwardedHost = headersList.get('x-forwarded-host');
  const forwardedProto = headersList.get('x-forwarded-proto');
  const forwardedPort = headersList.get('x-forwarded-port');
  const hostHeader = headersList.get('host');

  const primaryHost = forwardedHost?.split(',')[0]?.trim();
  let host =
    primaryHost ??
    hostHeader ??
    process.env.HOST ??
    'localhost:3000';

  if (!primaryHost && forwardedPort && !host.includes(':')) {
    host = `${host}:${forwardedPort}`;
  }

  let protocol =
    forwardedProto?.split(',')[0]?.trim() ??
    (process.env.NODE_ENV === 'development' ? 'http' : 'https');

  if (!protocol) {
    protocol = 'https';
  }

  return `${protocol}://${host}`;
};

export const getBaseUrlInClient = () => {
  if (typeof window !== 'undefined') {
    // Client-side: Use window.location
    const { protocol, host } = window.location;
    return `${protocol}//${host}`;
  }
};
